import { SnackbarType } from "../classes/enums/SnackbarTypeEnum";

const ICON_SIZE = 20;
const ICON_VIEWBOX = "0 0 24 24";

const iconProps = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  viewBox: ICON_VIEWBOX,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

export const SnackbarIconConfig = {
  [SnackbarType.SUCCESS]: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M9 12l2 2 4-4"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  [SnackbarType.INFO]: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M12 16v-4M12 8h.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  [SnackbarType.WARNING]: (
    <svg {...iconProps}>
      <polygon points="12,2 2,22 22,22" fill="currentColor" />
      <path
        d="M12 9v4M12 17h.01"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  [SnackbarType.ERROR]: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path
        d="M15 9l-6 6M9 9l6 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  [SnackbarType.LOADING]: (
    <svg {...iconProps} className="snackbar-spinner">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeDasharray="31.4 31.4"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
};

export const getSnackbarIcon = type => SnackbarIconConfig[type] || null;
